"use client";

import { Script } from "./script.js";

const TRAVELPAYOUTS_SCRIPT_URL = "https://tpembars.com/NTcyMzUx.js?t=572351";

export const TravelPayoutsScript = () => (
  <Script
    src={TRAVELPAYOUTS_SCRIPT_URL}
    strategy="afterInteractive"
    data-cmp-ab="2"
    async
  />
);
